import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {Link } from 'react-router-dom';
import '../index.css';
import ListItemButton from '@mui/material/ListItemButton';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Popover from '@mui/material/Popover';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import LogoutIcon from '@mui/icons-material/Logout';
import CarMaxIcon from '../CARMAXCCT_Icon_Yellow_Wordless.png';
import Grid from '@mui/material/Grid';
import AzureIcon from "../azureIcon.png";
import GenesysIcon from "../genesysIcon.webp";
import CarmaxSmallIcon from "../carmaxIconSmall.png"; 
import HomeIcon from '@mui/icons-material/Home';
import CarMaxLogo from "../CarMax-Logo_White.png"
import axios from 'axios';
const drawerWidth = 260;

export default function DrawerCustom() {

  useEffect(() => {
    menuItems();
  })

  const [menuData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const firstName = localStorage.getItem("firstname")
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menu_flag_WFM, set_menu_flag_WFM] = useState(false);

  const handlePopoverClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const openPopover = Boolean(anchorEl);
  const id = openPopover ? 'simple-popover' : undefined;

  const sendLogout = () => {
    window.location.href = "/.auth/logout?post_logout_redirect_uri=/logout" 
    let userName = localStorage.getItem('username')
    let event = {
      user: userName,
      time: new Date(Date.now()).toISOString(),
      action: "Admin UI Log-Out Successful",
    }
    axios.post('/api/send-splunk-data', { event },
      { headers: { 'Content-type': 'application/x-www-form-urlenconded' } })
      localStorage.clear();
      sessionStorage.clear();           
  };


  const handleClick = () => {
    setOpen(!open);
  };


 
  const menuItems = async () => {
    try {
      let roleData = localStorage.getItem('roles')
      let roleArray = roleData.split(",")

      if (menuData.length === 0) {
        for (const i in roleArray) {
          switch (roleArray[i]) {
            case "admin":
              menuData.push({ name: "WFM Configurations", url: "/configuration-wfm" })
              menuData.push({ name: "CAF Configurations", url: "/configuration-caf" })
              menuData.push({ name: "CR Configurations", url: "/configuration-cr" })
              menuData.push({ name: "AO Configurations", url: "/configuration-ao" })
              menuData.push({ name: "AS Configurations", url: "/configuration-as" })
              menuData.push({ name: "CBO Configurations", url: "/configuration-cbo" })
              break;
            case "wfm":
              if (!roleArray.includes("admin")) {
                menuData.push({ name: "WFM Configurations", url: "/configuration-wfm" })
              }
              set_menu_flag_WFM(true)
              break;
            case "cfr":
              if (!roleArray.includes("admin")) {
                menuData.push({ name: "CFR Configurations", url: "/configuration-cfr" })
              }
              break;
            case "caf":
              if (!roleArray.includes("admin")) {
                menuData.push({ name: "CAF Configurations", url: "/configuration-caf" })
              }
              break;
            case "cr":
              if (!roleArray.includes("admin")) {
                menuData.push({ name: "CR Configurations", url: "/configuration-cr" })
              }
              break;
              case "ao":
              if (!roleArray.includes("admin")) {
                menuData.push({ name: "AO Configurations", url: "/configuration-ao" })
              }
              break;
              case "as":
              if (!roleArray.includes("admin")) {
                menuData.push({ name: "AS Configurations", url: "/configuration-as" })
              }
              case "cbo":
              if (!roleArray.includes("admin")) {
                menuData.push({ name: "CBO Configurations", url: "/configuration-cbo" })
              }
              break;                         
            default:
              break;
          }
        }
      }
    }
    catch (err) {
      console.log(err)
    }
  }


  return (
    <Box sx={{ display: 'flex' }} >
      <CssBaseline />
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            backgroundColor: '#191919',
            boxShadow:"-3px 0 5px 0 #555"
          },
        }}
        variant="permanent"
        anchor="left"
      >


        <Toolbar sx={{ marginTop: '7%', marginLeft: '-5%', marginBottom: '6%' }}>
          <Grid container>
            <Grid item size={{xs:3}} sx={{ marginRight: 1  }}>
              <img alt="CarMax Icon" src={CarMaxIcon} className='inline'></img>
            </Grid>
            <Grid item size={{xs:8}} sx={{ padding: 0 }}>
              <Typography sx={{ color: '#fafbfc', float: 'left', fontSize: 22, marginTop: '5%' }} className='inline2'>CCT Web App</Typography>
              <Typography sx={{ fontSize: '65%', fontStyle: 'oblique', color: 'white', marginLeft: '1.5%', float: 'left' }}>Powered By:</Typography>
              <img alt="Azure Icon" src={AzureIcon} className='topIcons'></img>
              <img alt="Genesys Icon" src={GenesysIcon} className='topIcons'></img>
              <img alt="Small CarMax Icon" src={CarmaxSmallIcon} className='topIcons'></img>
            </Grid>
           
            <Grid container xs={12}>

            </Grid>
          </Grid>

        </Toolbar>
        <Divider />
        <center>
            <ListItem>    
           <center>
            <ListItemText sx={{ color: 'white', marginLeft: 2 }}>
            <Typography variant='h6'>Welcome, {firstName} <LogoutIcon aria-describedby={id} variant="contained" onClick={handlePopoverClick} sx={{ fontSize: 13 }} /></Typography>
            <Popover
        id={id}
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Link to="/auth/logout" onClick={sendLogout}><Typography sx={{ p: 2 }}> Log Out</Typography></Link>
      </Popover> 
            </ListItemText>
           </center>
            </ListItem> 
        </center>
        <List
          sx={{ width: '100%', maxWidth: 360}}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          <ListItemButton>
            <ListItemIcon>
              <HomeIcon sx={{ color: '#febd12' }} />
            </ListItemIcon>
            <Link to={"/configuration-cct-main"}><ListItemText sx={{color: 'white'}} primary="Home" /></Link>
          </ListItemButton>
          <ListItemButton onClick={handleClick}>
            <ListItemIcon>
              <DisplaySettingsIcon sx={{ color: '#febd12' }} />
            </ListItemIcon>
            <ListItemText sx={{color: 'white'}} primary="Configurations" />
            {open ? <ExpandLess sx={{color: 'white'}} /> : <ExpandMore sx={{color: 'white'}} />}
          </ListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {menuData.map((menuDatas, text, index) => (
                <ListItem ListItemButton key={index}>
                   <Link to={menuDatas.url} style={{ textDecoration: 'none', color: "white" }}><ListItemText primary={menuDatas.name} sx={{zIndex:1}} /></Link>  
                </ListItem>
              ))}
            </List>
          </Collapse>
        </List>

  

      </Drawer>
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
      >
        <Toolbar />
      </Box>
    </Box>
  );
}
